import React from 'react';
import Hero from '../components/homepage/Hero'
import OurMission from '../components/homepage/OurMissionSection';
import AboutSection from '../components/homepage/AboutSection';

export default function Home() {    

    return (
        <>
            <Hero />
            <OurMission />
            <AboutSection />
        </>
    );
}